<template>

  <div class="p-fluid report-field">
    <div :class="['p-grid report-field-header', {'report-field-header-small':section==='REPORT'}]">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label :for="guide.key">{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
    </div>
    <div class="p-fluid">
      <div class="p-inputgroup" v-if="!overview">
        <InputNumber v-model="number" 
                :placeholder="$t('report.'+section+'.'+guide.key+'_ph')"
                @input="dataChanged($event.value)" 
                :disabled="guide.disabled"
                :class="{'p-invalid':guide.invalid}"
                :minFractionDigits="decimal" :maxFractionDigits="decimal"
                :suffix="suffix ? ' '+suffix : null"
                :locale="$i18n.locale"
                :inputId="guide.key"
                />
        <Button v-if="suffixes && suffixes.length>1" icon="pi pi-sort" style="min-width: unset;" @click="changeSuffix"/>
      </div>

      <span v-else>{{ data[guide.key] ? data[guide.key] : '-' }}</span>

    </div>
  </div>

    <!-- <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
            <label>{{$t('report.REPORT.'+guide.key)}}</label>
            
        </div>
    </div> -->

    <!-- <div>mode: {{ guide.mode }}</div>
    <div>type: {{ guide.type }}</div>
    <div>key: {{ guide.key }}</div>
    <div>annotation: {{ guide.annotation }}</div> -->


</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      extras: Object,
      overview: Boolean
    },
  data() {
    return {
      number: null,
      // suffix: null,
      suffixes: [].concat(this.guide.suffix),
      suffixIndex: 0
    }
  },
  computed: {
    suffix: function() {
      if(this.suffixes!=null && this.suffixes.length>0 && this.suffixIndex>=0 && this.suffixIndex<this.suffixes.length) {
        return this.$functions.unit( this.suffixes[this.suffixIndex] , this.extras.imperial );
      }
      return null;
    },
    decimal: function() {
      if(this.suffix!=null) {
        return this.$functions.unitDecimals(this.suffix);
      }
      return 0;
    }
  },
  created() {

    let val = this.data[this.guide.key] ? this.data[this.guide.key].split(" ") : null;

    if(this.data[this.guide.key]!=null) {
      //Il dato è già popolato
      if(val.length>0 && val[1]!=null) {
        //Il suffisso c'è nel dato
        let tmpIndex = this.suffixes.indexOf(val[1]);
        this.suffixIndex = tmpIndex >=0 ? tmpIndex : 0; //Gestisce caso limite in cui il suffisso è sbagliato
      } else {
        //Il suffisso non c'è, è un numero ebbbbasta, mi baso sulla guida per assegnargliene eventualmente uno
        this.suffixIndex = 0;
      }
    } else {
      //Il dato non è popolato
      this.suffixIndex = 0;
    }

    // if(this.suffixes!=null && this.suffixes.length>0 && this.suffixIndex>=0 && this.suffixIndex<this.suffixes.length) {
    //   this.suffix = this.suffixes[this.suffixIndex];
    // }

    try {
      this.number = this.data[this.guide.key] ? Number(val[0]) : null;
    } catch(err) {
      console.error("ERROR DECODING OF "+this.guide.key+": "+this.data[this.guide.key]);
      this.number = null;
    }
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(newValue) {
      console.log("THIS NUMBER "+this.number);
      console.log("NEW VALUE "+newValue);
      this.number = newValue;
      this.$emit("update:data", { key: this.guide.key, value: newValue!=null ? newValue+" "+this.suffix : null});
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.number = null;
      }
    },
    changeSuffix() {
      if(this.suffixIndex>=this.suffixes.length-1) {
        this.suffixIndex = 0;
      } else {
        this.suffixIndex++;
      }
      this.dataChanged(this.number);
    }
    
  }
}
</script>

<style scoped>

</style>